'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
import { PurchaseLoadingFallbackSkeleton, PurchaseLoadingSkeleton } from '@/modules/service-purchase/components/purchase-loading-skeleton';
export default function ServicePurchaseLoading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={<PurchaseLoadingFallbackSkeleton />}><PurchaseLoadingSkeleton /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}